var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6729",
    "data-name": "Group 6729",
    transform: "translate(0.479 0.396)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4733",
    "data-name": "Rectangle 4733",
    width: 20,
    height: 20,
    rx: 5,
    transform: "translate(-0.479 -0.396)",
    fill: "#00a093"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6728",
    "data-name": "Group 6728",
    transform: "translate(3.879 5.39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M36.732,35.147a4.76,4.76,0,0,1-1.37.375,2.392,2.392,0,0,0,1.049-1.32,4.776,4.776,0,0,1-1.515.579,2.388,2.388,0,0,0-4.066,2.176,6.773,6.773,0,0,1-4.918-2.493,2.388,2.388,0,0,0,.738,3.185,2.369,2.369,0,0,1-1.081-.3c0,.01,0,.02,0,.03a2.387,2.387,0,0,0,1.914,2.339,2.4,2.4,0,0,1-1.077.041,2.388,2.388,0,0,0,2.229,1.657,4.816,4.816,0,0,1-3.532.988A6.785,6.785,0,0,0,35.548,36.69q0-.155-.007-.309a4.838,4.838,0,0,0,1.191-1.235Z",
    transform: "translate(-25.103 -34.028)",
    fill: "#f1f2f2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.4c2350a0fda397a720b426ffe0b55b1f.svg";
export { ForwardRef as ReactComponent };